
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { useTheme } from '@mui/material/styles';
// Authentication pages components
import {Button, FormControl, FormHelperText, Paper, Select} from "@mui/material";
import Fade from "@mui/material/Fade";
import MDButton from "../../../../components/MDButton";
import MenuItem from "@mui/material/MenuItem";
import {ToggleButton, ToggleButtonGroup} from "@mui/lab";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setLanguage} from "../../../../actions";
import {useTranslation} from "react-i18next";
import useMediaQuery from '@mui/material/useMediaQuery';
import {navbarIconButton} from "../../../../examples/Navbars/DashboardNavbar/styles";
import LanguageIcon from "@mui/icons-material/Language";
import IconButton from "@mui/material/IconButton";
function BasicLayout({ image, children }) {
    const languageList = [
        {
            id: 1,
            label: 'En',
            lang:'en',
            value: 1
        },
        {
            id: 2,
            label: '中文',
            lang:'zh',
            value: 2
        },
        {
            id: 3,
            label: 'Fr',
            lang:'fr',
            value: 3
        },
    ]
    const language = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm')); // 检查是否是xs断点
    const handleToggle = (event, lang) => {
        dispatch(setLanguage(lang));
        i18n.changeLanguage(lang)
    };

    const handleLanguageSelectChange = (event) => {
        dispatch(setLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang));
        i18n.changeLanguage(languageList.find((lang) => lang.value === event.target.value )?.lang);
        setLanguageSelect(event.target.value);
    };
    const handleLanguageSelectClose = () => {
        setOpenLanguageSelect(false);
    };

    const handleLanguageSelectOpen = () => {
        setOpenLanguageSelect(true);
    };

    const positionStyle = isXs
        ? { top: '5%', right: 'none' }
        : { top: '5%', right: '5%', bottom: 'none' };

    const [languageSelect ,setLanguageSelect] = useState(languageList.find((lang)=>lang.lang === i18n.language).value);
    const [openLanguageSelect,setOpenLanguageSelect] = useState(false);


    return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid container justifyContent="center" alignItems="center" height="100%">
          <Fade in={true}>
              <Grid item container
                    xs={12}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={6}
                    justifyContent="space-evenly"
                    alignItems="center"
                    sx={{
                        boxShadow:'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;',
                        filterDrop:'drop-shadow(16px 16px)',
                        background:'rgba(250,250,250,0.3)',padding:'5% 0',
                        borderRadius:"30px",
                        zIndex:'1',

              }}
              >
                  {children}

                      {/*<MDButton color={'warning'} variant={'gradient'}>*/}
                      {/*    language*/}
                      {/*</MDButton>*/}

                  {process.env.REACT_APP_LANG_TRANSLATION === 'true' &&

                      // <ToggleButtonGroup
                      //     color="primary"
                      //     value={language}
                      //     exclusive
                      //     onChange={handleToggle}
                      //     aria-label="Platform"
                      //     sx={{
                      //         position:'fixed',
                      //         ...positionStyle,// 在 md 断点为 5%，在 xs 断点为 none
                      //         zIndex:'9999',
                      //         borderRadius:5,
                      //         background:'white',
                      //         padding:0,
                      //         '& .MuiToggleButton-root': {
                      //             fontSize: { xs: '0.875rem', md: '0.75rem' },  // 调整字体大小，xs 时较大模拟 'medium' 效果
                      //             padding: { xs: '8px 0px', md: '6px 0px' },
                      //             width: 40,// 调整内边距，xs 时较大模拟 'medium' 效果
                      //         },
                      //         '& .Mui-selected':{
                      //             color:'#3f50b5',
                      //             background:'rgba(63,80,181,0.3)'
                      //         }
                      //     }}
                      // >
                      //     <ToggleButton disableRipple value="en" sx={{border:'none',fontWeight:'bold'}}>
                      //         {/*<span className="fi fi-ca"></span>*/}
                      //         <div style={{paddingLeft:'5px'}}>{language === 'zh' ? '英' : 'EN'}</div></ToggleButton>
                      //     <ToggleButton disableRipple value="zh" sx={{border:'none',fontWeight:'bold'}}>
                      //         {/*<span className="fi fi-cn"></span>*/}
                      //         <div style={{paddingLeft:'5px'}}>{language === 'en' ? 'ZH' : '中'}</div></ToggleButton>
                      // </ToggleButtonGroup>
                      <IconButton
                          size="small"
                          disableRipple
                          color="inherit"
                          disableFocusRipple
                          aria-label="toggle language"
                          data-testid="language-dropdown"
                          // sx={navbarIconButton}
                          sx={{
                              position:'fixed',
                              ...positionStyle,// 在 md 断点为 5%，在 xs 断点为 none
                              zIndex:'9999',
                              borderRadius:5,
                              background:'white',
                              padding:0,
                              '& .MuiToggleButton-root': {
                                  fontSize: { xs: '0.875rem', md: '0.75rem' },  // 调整字体大小，xs 时较大模拟 'medium' 效果
                                  padding: { xs: '8px 0px', md: '6px 0px' },
                                  width: 40,// 调整内边距，xs 时较大模拟 'medium' 效果
                              },
                              '& .Mui-selected':{
                                  color:'#3f50b5',
                                  background:'rgba(63,80,181,0.3)'
                              }
                          }}
                      >
                          <FormControl fullWidth>
                              <Select
                                  sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": { border: 0 },
                                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                          {
                                              border: 0,
                                          },
                                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                          {
                                              border: 0,
                                          },
                                  }}
                                  open={openLanguageSelect}
                                  value={languageSelect}
                                  onChange={handleLanguageSelectChange}
                                  onClose={handleLanguageSelectClose}
                                  onOpen={handleLanguageSelectOpen}
                                  renderValue={(value)=>{
                                      return(
                                          <MDButton sx={{padding:"4px"}} variant={'text'} color="info" startIcon={<LanguageIcon/>} onClick={handleLanguageSelectOpen}>
                                              {languageList.find(v=>v.value === value)?.label || ""}
                                          </MDButton>
                                      )
                                  }}
                                  MenuProps={{
                                      // PaperProps: {
                                      //     'data-testid': 'language-menu', // 给 Menu 添加 data-testid，便于测试
                                      //     sx: {
                                      //         maxHeight: 300, // 设置菜单的最大高度
                                      //     },
                                      // },
                                      disablePortal: true, // 禁用 Portal 渲染，菜单会在 Select 内部渲染
                                      // getContentAnchorEl: null, // 防止菜单锚点定位问题
                                  }}
                              >
                                  <MenuItem value={1} data-testid="language-option-en">English</MenuItem>
                                  <MenuItem value={2} data-testid="language-option-zh">中文 (Chinese)</MenuItem>
                                  <MenuItem value={3} data-testid="language-option-fr">Français (Canada)</MenuItem>
                              </Select>
                          </FormControl>
                      </IconButton>

                  }





              </Grid>
          </Fade>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
